import React from 'react';
import { Switch, Route, withRouter, Redirect } from 'react-router';
import { connect } from 'react-redux';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import UsersList from './UsersList';
import EmployeeSales from './EmployeeSales/EmployeeSales';
import WorkperiodDetails from './WorkperiodDetails/WorkperiodDetails';

class Users extends React.Component {
    render() {
        return (
            <TransitionGroup>
                <CSSTransition
                    key={this.props.location.key}
                    classNames="fade"
                    timeout={200}
                >
                    <Switch>
                        <Route path="/admin/users" exact component={UsersList} />
                        <Route path="/admin/users/sales/:userId" exact component={EmployeeSales} />
                        <Route path="/admin/users/sales/:userId/workperiod/:workperiodId" component={WorkperiodDetails} />
                    </Switch>
                </CSSTransition>
            </TransitionGroup>
        );
    }
}

export default withRouter(connect()(Users));
